import { z } from 'zod';

export enum FilterOperator {
  Equals = 'Equals',
  NotEquals = 'NotEquals',
  GreaterThan = 'GreaterThan',
  GreaterThanOrEqualTo = 'GreaterThanOrEqualTo',
  LessThan = 'LessThan',
  LessThanOrEqualTo = 'LessThanOrEqualTo',
  Contains = 'Contains',
  DoesNotContain = 'DoesNotContain',
  StartsWith = 'StartsWith',
  EndsWith = 'EndsWith',
  IsOneOf = 'IsOneOf',
  IsNotOneOf = 'IsNotOneOf',
  IsEmpty = 'IsEmpty',
  IsNotEmpty = 'IsNotEmpty',
}

export enum FilterMatchRule {
  All = 'All',
  Any = 'Any',
}

export enum CaseSensitivity {
  ExactMatch = 'ExactMatch',
  IgnoreCase = 'IgnoreCase',
}

export enum SortDirection {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

const fieldPathRegex = /^[a-zA-Z_]\w*(\.[a-zA-Z_]\w*)*$/;
const fieldPathErrorMessage =
  'Field path must use dot notation only (e.g., "startTime" or "rawJson.type.coding")';

const FilterOperationSchema = z.object({
  id: z.uuid(),
  fieldToFilter: z.string().regex(fieldPathRegex, fieldPathErrorMessage),
  operator: z.enum(FilterOperator),
  caseSensitive: z.enum(CaseSensitivity),
  value: z.unknown(),
});

export const SortConfigSchema = z
  .object({
    fieldToSort: z.string(),
    sortDirection: z.enum(SortDirection).default(SortDirection.Descending),
  })
  .transform((config) => {
    if (!config.fieldToSort) {
      return undefined;
    }
    return config;
  });

export const FilterConfigSchema = z.object({
  matchRule: z.enum(FilterMatchRule),
  filterOperations: z.array(FilterOperationSchema),
});

export type FilterOperation = z.infer<typeof FilterOperationSchema>;
